<form class="card mb-5" [formGroup]="form">
  <div class="container section-container">
    <div class="row">
      <div class="col-12 setup-status">
        <mat-checkbox [checked]="is_setup()" [disabled]="true">Correo de vacaciones activado</mat-checkbox>
        <p class="field-hint">Este campo es de solo lectura. El correo se activa/desactiva automáticamente según tus vacaciones.</p>
      </div>
      <div class="col-12">
        <label class="field-label">Cuerpo del correo de vacaciones</label>
        <editor
          formControlName="out_of_work_mail_body"
          [apiKey]="tiny_mce_api_key"
          cloudChannel="6"
          [disabled]="fields_disabled()"
          id="out_of_work_mail_body"
          [init]="tiny_mce_init"
          initialValue=""
          [inline]="false"
          tagName="div"
        ></editor>
        <p class="field-hint">
          Escribe el contenido del correo de vacaciones. <strong>No incluyas la firma</strong>, se añadirá automáticamente.
        </p>
      </div>
    </div>
    <button class="mb-4" mat-flat-button color="accent" type="button" (click)="save_absence_email()" [disabled]="save_disabled()">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </div>
</form>
